{
    "actions": {
        "row": {
            "update_label": "Update label",
            "delete": "Delete rule"
        }
    },
    "filter": {
        "placeholder": {
            "contract": "Filter by contrat",
            "bank_code": "Filter by bank code",
            "rank": "Filter by rank",
            "recipient": "Filter by environment",
            "legal_name": "Filter by organization name",
            "partner": "Filter by ID Partner",
            "extra_1": "Filter by extra 1",
            "extra_2": "Filter by extra 2",
            "label": "Filter by label"
        }
    },
    "keys": {
        "contract": "Contract",
        "bank_code": "Bank code",
        "rank": "Rank",
        "recipient": "Environment",
        "legal_name": "Organization name",
        "partner": "ID Partner",
        "application": "Application",
        "extra_1": "Extra 1",
        "extra_2": "Extra 2",
        "label": "Label"
    },
    "modal": {
        "update_label": {
            "title": "Edit label",
            "text": "Label",
            "success": "Rule successfully edited !",
            "error": "An error occurred while editing the rule"
        },
        "delete": {
            "title": "Delete rule",
            "text": "You are about to delete this rule.",
            "success": "Rule successfully deleted !",
            "error": "An error occurred while deleting the rule",
            "warning": "Please confirm the deletion."
        },
        "import": {
            "explanations": {
                "header": "It is possible to perform operations by uploading a file. The file is in CSV format and must contain the following 10 columns :",
                "action": "action : This column corresponds to the action to be performed on each line. The two possible values are \"ADD\" or \"DELETE\".",
                "recipient": "recipient : Environment on which to send notifications",
                "partner": "partner : ID Partner on which the TPE is configured (visible in the \"Partner organizations\" tab)",
                "contract": "contract : Contract number with 7 digits",
                "rank": "rank : Allows to identify a particular rank (example \"001\"). To identify \"all ranks\", simply leave the field empty.",
                "bankCode": "bankCode : Acquirer bank code",
                "application": "application : Identifies the application of the contract. You can mention \"CBEMV\" for CB Proximity, \"CBCLESS\" for CB Contactless or \"CBVAD\" for CB Distance Selling.",
                "extra1": "extra1 : Additional field created initially when configuring the Push Payment API (optional)",
                "extra2": "Additional field created initially when configuring the Push Payment API (optional)",
                "label": "You can mention a label for each rule (optional)"
            },
            "confirmation": "This operation will add {{add}} rule(s) and delete {{delete}} rule(s). Do you want to continue ?",
            "success": "Operations successful !",
            "error": {
                "header": "We have processed {{rulesProcessed}} rule(s), the following rules have not been processed :",
                "invalid_file": "This file is not compatible (.csv only)",
                "UNEXPECTED_ERROR": "An error occurred, please try again later."
            }
        }
    },
    "rank": {
        "all": "All ranks"
    }
}